/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from "react";
import Button from "calcite-react/Button";
// import Menu, { MenuItem } from "calcite-react/Menu";
import Modal from "calcite-react/Modal";
//import WrenchIcon from "calcite-ui-icons-react/WrenchIcon";
//import XCircleIcon from "calcite-ui-icons-react/XCircleIcon";
import MeasureLineIcon from "calcite-ui-icons-react/MeasureLineIcon";
import MeasureAreaIcon from "calcite-ui-icons-react/MeasureAreaIcon";
import ShareIcon from "calcite-ui-icons-react/ShareIcon";
import "./MapActions.scss";
import { MapContext } from "../../context/MapContext";
import DistanceMeasurement2D from "@arcgis/core/widgets/DistanceMeasurement2D";
import AreaMeasurement2D from "@arcgis/core/widgets/AreaMeasurement2D";
import SaveNShare from "./SaveNShare/SaveNShare";

function MapActions(props) {
  const {
    basemapOpen,
    setBasemapOpen,
    measureToolOpen,
    setMeasureToolOpen,
    areaToolOpen,
    setAreaToolOpen,
  } = props;
  //const modalRef = useRef(null);
  //const [dropdownOpen, setDropdownOpen] = useState(false);

  const [saveAndShareOpen, setSaveAndShareOpen] = useState(false);
  const [mapObject] = useContext(MapContext);

  const handleMeasureTool = () => {
    setMeasureToolOpen(!measureToolOpen);
    //close others
    !measureToolOpen && areaToolOpen && setAreaToolOpen(false);
    !measureToolOpen && basemapOpen && setBasemapOpen(false);
  };

  //handle starting/stopping/displaying/hiding line measure tool
  useEffect(() => {
    if (measureToolOpen && !window.lineTool) {
      window.lineTool = new DistanceMeasurement2D({
        view: mapObject.view,
      });
      window.lineTool.viewModel.start();
      mapObject.view.ui.add(window.lineTool, "top-right");
    } else if (window.lineTool) {
      window.lineTool?.destroy();
      window.lineTool = null;
    }
  }, [
    measureToolOpen,
    areaToolOpen,
    basemapOpen,
    mapObject?.view,
    setAreaToolOpen,
    setBasemapOpen,
  ]);

  const handleAreaTool = () => {
    setAreaToolOpen(!areaToolOpen);
    //close others
    !areaToolOpen && measureToolOpen && setMeasureToolOpen(false);
    !areaToolOpen && basemapOpen && setBasemapOpen(false);
  };

  //handle starting/stopping/displaying/hiding area measure tool
  useEffect(() => {
    if (areaToolOpen && !window.areaTool) {
      window.areaTool = new AreaMeasurement2D({
        view: mapObject.view,
      });
      window.areaTool.viewModel.start();
      mapObject.view.ui.add(window.areaTool, "top-right");
    } else if (window.areaTool) {
      window.areaTool?.destroy();
      window.areaTool = null;
    }
  }, [
    measureToolOpen,
    areaToolOpen,
    basemapOpen,
    mapObject?.view,
    setBasemapOpen,
    setMeasureToolOpen,
  ]);

  const handleSaveAndShare = () => {
    if (saveAndShareOpen) {
      setSaveAndShareOpen(false);
    } else {
      setSaveAndShareOpen(true);
    }
  };

  const modalEl = document.getElementById("saveModal");

  return (
    <>
      <div id="saveModal" />
      <div className="mapActions">
        <div className="dropdownArea">
          <Button
            className={`button measureLine ${measureToolOpen ? "active" : ""}`}
            onClick={handleMeasureTool}
            iconButton
            title="Measure Line Tool"
            icon={<MeasureLineIcon size={16} />}
          ></Button>
          <Button
            className={`button measureArea ${areaToolOpen ? "active" : ""}`}
            onClick={handleAreaTool}
            iconButton
            title="Measure Area Tool"
            icon={<MeasureAreaIcon size={16} />}
          ></Button>

          <Button
            className={`button saveShare ${saveAndShareOpen ? "active" : ""}`}
            onClick={handleSaveAndShare}
            iconButton
            title="Save & Share"
            icon={<ShareIcon size={16} />}
          ></Button>
        </div>
        <Modal
          open={saveAndShareOpen}
          onRequestClose={() => setSaveAndShareOpen(false)}
          title="Save and Share"
          appElement={modalEl}
          dialogStyle={{
            width: "50%",
          }}
        >
          <SaveNShare />
        </Modal>
      </div>
    </>
  );
}

export default MapActions;
